<template>
    <template v-if="!hasTiles">
        <div class="spinner">
            <div class="d-flex justify-content-center">
                <div class="spinner-grow text-secondary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <template v-for="tile in tiles">
            <div
                v-if="tile.visible"
                class="col-6 col-md-4 my-3 job-tile"
            >
                <a
                    :class="config.boxClass"
                    :href="config.jobListUrl + '?business[]=' + tile.name"
                    :style='{
                        backgroundColor: `rgba(${ config.boxBlendColor })`,
                        backgroundImage: `url("${ tile.image }")`
                        }'
                    class="job-box-link ratio ratio-1x1">
                    <h6 :class="[config.jobTitleClass, config.boxHeadlineClass]" class="job-group">{{ tile.title }}</h6>
                </a>
            </div>
        </template>
    </template>
</template>

<script lang="ts" setup>
import axios from "axios";
import {computed, ref} from "vue";

interface Tile {
    name: string
    title: string
    image: string
    visible?: boolean
}

interface Props {
    tiles: Array<Tile>
    config: any
}

const props = defineProps<Props>();

const config = props.config;
const tiles = ref(props.tiles);

// check if there are any active tiles / tiles are loaded
const hasTiles = computed(() => {
    return Object.values(tiles.value).find(tile => {
        return tile.visible === true;
    }) !== undefined;
});

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// get active filters and make tile visible
if (config.filterUrl) {
    axios.post(config.filterUrl)
        .then(response => {
            const activeFilters = Object.keys(response.data);
            tiles.value.map(tile => {
                tile.visible = activeFilters.includes(tile.name);
                tile.name = encodeURIComponent(tile.name);
                return tile;
            });
        });
}
</script>
